module.exports = __webpack_public_path__ + "img/app-down.06bff297.png";